import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgStyle, NgClass, AsyncPipe } from '@angular/common';
import { StorageImage } from '../storage-images.util';
import { StorageImageService } from '../storage-image.service';

/**
 * Reusable grid of the images saved in shared storage. Highlights the images
 * whose paths are passed in `selectedPaths`, emits `select` when one is
 * clicked, and shows a delete button on hover that permanently removes the
 * image from storage (emitting `deleted` once it is gone).
 */
@Component({
  selector: 'app-image-picker',
  templateUrl: './image-picker.component.html',
  styleUrls: ['./image-picker.component.scss'],
  imports: [NgStyle, NgClass, AsyncPipe]
})
export class ImagePickerComponent {
  private storageImages = inject(StorageImageService);

  @Input() images: StorageImage[] = [];
  @Input() selectedPaths: string[] = [];

  @Output() select = new EventEmitter<StorageImage>();
  @Output() deleted = new EventEmitter<StorageImage>();

  /** Paths currently mid-deletion, used to disable the button while it runs. */
  deleting = new Set<string>();

  isSelected(img: StorageImage): boolean {
    return this.selectedPaths.includes(img.path);
  }

  onSelect(img: StorageImage) {
    this.select.emit(img);
  }

  onDelete(img: StorageImage, event: MouseEvent) {
    event.stopPropagation();
    const name = img.path.split('/').pop();
    if (this.deleting.has(img.path) || !confirm(`Delete "${name}"? This permanently removes it from storage.`)) {
      return;
    }
    this.deleting.add(img.path);
    this.storageImages.deleteImage(img.path)
      .then(() => this.deleted.emit(img))
      .catch(error => console.log(error))
      .finally(() => this.deleting.delete(img.path));
  }
}
